import axiosInstance from './axiosInstance';

const AT_API_URL = '/at';

const atService = {
  // Login methods
  async getLoginById(idempresa) {
    try {
      const response = await axiosInstance.get(`${AT_API_URL}/logins/getById.php?idempresa=${idempresa}`);
      return response.data !== 'NOK' ? response.data : {};
    } catch (error) {
      console.error('Erro ao obter login AT:', error);
      throw error;
    }
  },

  async setLogin(loginData) {
    try {
      const response = await axiosInstance.post(`${AT_API_URL}/logins/set.php`, loginData);
      return response.data;
    } catch (error) {
      console.error('Erro ao guardar login AT:', error);
      throw error;
    }
  },

  async unsetLogin(idempresa, environment = null) {
    try {
      const data = { idempresa };
      if (environment) {
        data.environment = environment;
      }
      const response = await axiosInstance.post(`${AT_API_URL}/logins/unset.php`, data);
      return response.data;
    } catch (error) {
      console.error('Erro ao remover login AT:', error);
      throw error;
    }
  },

  async registerSeries(seriesData) {
    try {
      const response = await axiosInstance.post(`${AT_API_URL}/webservice/series/registarSerie.php`, seriesData);
      return response.data;
    } catch (error) {
      console.error('Erro ao registar série na AT:', error);
      throw error;
    }
  },

  async cancelSeries(cancelData) {
    try {
      const response = await axiosInstance.post(`${AT_API_URL}/webservice/series/anularSerie.php`, cancelData);
      return response.data;
    } catch (error) {
      console.error('Erro ao anular série na AT:', error);
      throw error;
    }
  }
};

export default atService;
